module.exports = __webpack_public_path__ + "static/media/home_japan_main2.400b5012.svg";